import { FormikState, FormikHandlers } from 'formik';
import React from 'react';

import { NumberFormatField } from '../number-format-field';

type Props = Omit<React.ComponentProps<typeof NumberFormatField>, 'value' | 'error' | 'helperText' | 'defaultValue'> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikHandlers & FormikState<any>;
  name: string;
};

const FormikNumberFormatField: React.FC<Props> = (props: Props) => {
  const { name, formik, onChange, ...rest } = props;
  const meta = formik.getFieldMeta(name);

  return (
    <NumberFormatField
      {...rest}
      name={name}
      value={meta.value}
      onChange={onChange ?? formik.handleChange}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
    />
  );
};

export { FormikNumberFormatField };
